import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs';

import { TagRequester } from '../../requesters';
import { TagAdapter } from '../adapters/tag.adapter';
import { setProject } from './app.actions';
import { setGloballyAvailableTags } from './tag.actions';

@Injectable()
export class TagEffects {
	// ##########################################################
	// Navigation Effects
	// ##########################################################

	// ##########################################################
	// Business Effects
	// ##########################################################
	public setTags$ = createEffect(() =>
		this.actions$.pipe(
			ofType(setProject),
			switchMap(() => this.tagRequester.getAvailableTags(true)),
			map((resp) => this.tagAdapter.generateTags(resp)),
			map((res) =>
				setGloballyAvailableTags({
					availableTags: res,
				})
			)
		)
	);

	// ##########################################################
	// Confirmation popup effects
	// ##########################################################

	public constructor(
		private readonly actions$: Actions,
		private readonly tagRequester: TagRequester,
		private readonly tagAdapter: TagAdapter
	) {}
}
